export default function () {
  if (document.querySelector('#form_bigteam')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "bigteam" */ '@organisms/bigteam/form'
    );
  }
}
